'use client';

// Fase 7 · K4 · Dispara ViewContent ao montar a página /precos.
// Componente client-only, no-op se o tracker (window.Track) ainda não inicializou.

import { useEffect } from 'react';

import { viewContent } from '@/lib/tracking/dispatch';

export function PrecosTracking() {
  useEffect(() => {
    viewContent({ content_name: 'precos-page', content_category: 'pricing' });
  }, []);
  return null;
}
